import { render, staticRenderFns } from "./BigErrorBox.vue?vue&type=template&id=6d316578&scoped=true&"
import script from "./BigErrorBox.vue?vue&type=script&lang=js&"
export * from "./BigErrorBox.vue?vue&type=script&lang=js&"
import style0 from "./BigErrorBox.vue?vue&type=style&index=0&id=6d316578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d316578",
  null
  
)

export default component.exports